import { baseService } from "../core/baseService";

const BASE_URL = "/nurse/api/HealthInfoUserView";

// Sabit tipler - her zaman seçili ve değiştirilemez
export const FIXED_TYPE_IDS = [1, 2, 10]; // ALLERGIES, HABITS, PREGNANT

// Tip ID'leri enum
export enum HealthInfoTypeId {
    ALLERGIES = 1,
    HABITS = 2,
    BLOOD_PRESSURE = 3,
    DISEASES = 4,
    DRUGS = 5,
    EXPOSURES = 6,
    FAMILY_HISTORY = 7,
    HEIGHT_WEIGHT = 8,
    OTHER = 9,
    PREGNANT = 10,
    PREVIUS_DISEASE = 11,
    PREVIUS_SURGERIES = 12,
    RARE_DISEASE = 13,
    SPECIAL_NOTES = 14,
}

// Response tipleri
export interface HealthInfoViewType {
    typeId: number;
    name: string;
    caption: string;
    isSelected: boolean;
}

export interface HealthInfoViewTypesResponse {
    success: boolean;
    data: HealthInfoViewType[];
}

// User preferences response (sadece ID'ler)
export interface UserPreferencesResponse {
    issuccess: boolean;
    data: {
        typeids: number[]; // Seçili olan typeId'ler sıralı
    };
    statuscode: number;
    message: string;
}

export interface AddHealthInfoViewRequest {
    userId: number;
    cuser: string;
    typeId: number;
}

export interface ApiResponse<T> {
    success: boolean;
    data?: T;
    message?: string;
    error?: string;
    statusCode?: number;
}

export const healthInfoUserViewService = {
    /**
     * Kullanıcının seçili tip ID'lerini getirir
     * @param userId - Kullanıcı ID'si
     */
    getUserPreferences: async (userId: number): Promise<UserPreferencesResponse> => {
        return baseService.getAll<UserPreferencesResponse>(
            `${BASE_URL}/GetUserPreferences/${userId}`
        );
    },

    /**
     * Kullanıcı için yeni bir tip ekler
     * NOT: Sabit tipler (1, 2, 10) eklenemez
     * @param request - Eklenecek tip bilgileri
     */
    addHealthInfoViewForUser: async (
        request: AddHealthInfoViewRequest
    ): Promise<ApiResponse<number>> => {
        // Sabit tip kontrolü
        if (FIXED_TYPE_IDS.includes(request.typeId)) {
            throw new Error(
                `TypeId ${request.typeId} is a fixed type and cannot be added or removed.`
            );
        }

        return baseService.add<ApiResponse<number>>(
            `${BASE_URL}/AddHealthInfoViewForUser`,
            request
        );
    },

    /**
     * Kullanıcı için bir tipi soft delete yapar
     * NOT: Sabit tipler (1, 2, 10) silinemez
     * @param userId - Kullanıcı ID'si
     * @param typeId - Silinecek tip ID'si
     */
    deleteHealthInfoViewForUser: async (
        userId: number,
        typeId: number
    ): Promise<ApiResponse<number>> => {
        // Sabit tip kontrolü
        if (FIXED_TYPE_IDS.includes(typeId)) {
            throw new Error(
                `TypeId ${typeId} is a fixed type and cannot be deleted.`
            );
        }

        return baseService.delete<ApiResponse<number>>(
            `${BASE_URL}/DeleteHealthInfoViewForUser/${userId}/`,
            typeId
        );
    },

    /**
     * Bir tip ID'nin sabit tip olup olmadığını kontrol eder
     * @param typeId - Kontrol edilecek tip ID'si
     */
    isFixedType: (typeId: number): boolean => {
        return FIXED_TYPE_IDS.includes(typeId);
    },
};
